export const GET_ADDRESS_REQUESTED = 'GET_ADDRESS_REQUESTED';
export const GET_ADDRESS_SUCCESS   = 'GET_ADDRESS_SUCCESS';
export const GET_ADDRESS_FAILED    = 'GET_ADDRESS_FAILED';
export const UPDATE_ADDRESS        = 'UPDATE_ADDRESS';

export const GET_COURIER_REQUESTED = 'GET_COURIER_REQUESTED';
export const GET_COURIER_SUCCESS   = 'GET_COURIER_SUCCESS';
export const GET_COURIER_FAILED    = 'GET_COURIER_FAILED';
